<template>
    <div class="onboarding-container onboarding-dropdown row visible-on col-md-8 col-lg-5 col-md-offset-1 col-lg-offset-3">
        <span ref="form-label" :class="['col-xs-12 col-sm-5 col-md-5 col-lg-4 form-label', fixStyle]">{{ label }}</span>
        <div v-clickoutside="closeDropdownItems" :class="['dropdown-container col-xs-12 col-sm-5 col-md-7 col-lg-8', isDisabled ? 'disable-bkg' : '', internalErrorMessage ? 'error-border' : 'normal-border']">
          <div :class="['dropdown-selected form-component']" @click="toggle">
            <input ref="input" :value="inputValue" :placeholder="placeholder" autocomplete="off" @input="onInput"/>
            <span class="arrow" :class="showItem && 'up-arrow'"/>
          </div>
          <ul v-if="showItem" class="dropdown-items">
            <li class="dropdown-item form-component custom-color" v-for="(item, index) in searchedOptions" v-show="item.isShow" :key="index" @click="select(item.id)">{{ item.text }}</li>
            <li class="dropdown-item form-component no-data custom-color" v-show="searchedOptions.length < 1">无匹配数据</li>
          </ul>
        </div>
        <div v-if="notice" class="col-xs-12 col-sm-offset-5 col-md-offset-5 col-lg-offset-4 col-sm-7 col-md-7 col-lg-8 notice-text">{{ this.notice }}</div>
        <div v-if="internalErrorMessage" class="col-xs-12 col-sm-offset-5 col-md-offset-5 col-lg-offset-4 col-sm-7 col-md-7 col-lg-8 error-text">{{ this.internalErrorMessage }}</div>
    </div>
</template>
<script>
import Clickoutside from 'element-ui/src/utils/clickoutside'
import { onboardingMixin } from './mixin.js'

// @label: the field title.
// @isEditable: whether this field can be edited.
// @notice: the notice message displayed on the bottom of the field.
// @placeholder: when value is empty, the placeholder text displayed on the field.
// @options: all options that can be selected.
// @isRequired: whether this field can be empty.

export default {
  directives: {
    Clickoutside
  },
  props: ['label', 'isEditable', 'notice', 'placeholder', 'value', 'options', 'isRequired'],
  mixins: [onboardingMixin],
  data () {
    return {
      searchedOptions: [],
      isDisabled: this.isEditable === 'false',
      displayText: '',
      showItem: false,
      internalValue: '',
      internalErrorMessage: '',
      noMatchOption: false,
      inputValue: null
    }
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  created () {
    this.searchedOptions = this.options.map(item => {
      item.isShow = true
      return item
    })
  },
  mounted () {
    this.match(Number(this.value))
    this.inputValue = this.displayText
  },
  watch: {
    value: {
      handler (val, oldVal) {
        this.internalValue = val
      },
      immediate: true
    },
    internalValue (val) {
      this.$emit('change', val)
      this.match(val)
    },
    showItem (val) {
      if (val) {
        this.searchedOptions.forEach(item => { item.isShow = true })
        this.inputValue = null
        this.$refs.input.focus()
      } else {
        this.inputValue = this.displayText
      }
    },
    '$i18n.locale' (val) {
      if (this.internalValue) {
        this.match(this.internalValue)
      }
      this.validate()
    }
  },
  methods: {
    closeDropdownItems (event) {
      this.showItem = false
    },
    validate () {
      if (this.fieldIsRequired(this.isRequired) && !this.internalValue) {
        this.internalErrorMessage = this.isRequiredMessage
        return false
      }
      return true
    },
    match (value) {
      const option = this.searchedOptions.find(item => item.id === parseInt(value))
      if (option) {
        this.displayText = option.text
        this.inputValue = this.displayText
      }
    },
    toggle (event) {
      if (this.isDisabled) {
        return
      }
      if (this.showItem && event && event.target.tagName === 'INPUT') {
        return
      }
      this.showItem = !this.showItem
    },
    select (id) {
      this.toggle()
      this.internalValue = id
      this.internalErrorMessage = ''
    },
    onInput (event) {
      const value = event.target.value.toLowerCase()
      this.searchedOptions.forEach(item => {
        if (item.text.toLowerCase().search(value) > -1) {
          item.isShow = true
        } else {
          item.isShow = false
        }
      })
      this.inputValue = event.target.value
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/onboarding-common.scss';
.onboarding-dropdown {
  margin-bottom: 1.2rem;
  .dropdown-container {
    z-index: 99;
    position: relative;
    padding: 0;
    display: inline-flex;
    flex-direction: column;
    user-select: none;
    .dropdown-selected {
      position: relative;
      z-index: 99;
      padding: 0 0.6rem;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .arrow {
        display: inline-block;
        height: 1.5rem;
        width: 1.6rem;
        user-select: none;
        background: url(~@/assets/image/onboarding/common/arrow-down.png) no-repeat center;
        background-size: cover;

        &.up-arrow {
          background-image: url(~@/assets/image/onboarding/common/arrow-up.png);
        }
      }
      input {
        width: 100%;
        font-size: medium;
      }
    }
    .dropdown-items {
      position: relative;
      z-index: 100;
      max-height: 12rem;
      overflow-y: scroll;
      padding: 0 0.6rem;
      .dropdown-item {
        width: 100%;
        display: flex;
        align-items: center;
        border-top: solid 1px gray;
      }
      .dropdown-item:hover {
        color: $common-color;
        cursor: pointer;
      }
      .no-data.dropdown-item:hover {
        color: unset;
        cursor: default;
      }
    }
  }
}
/* 小型设备（平板电脑，768px 起） */
@media (min-width: 768px) {
    .arrow {
      width: 20px !important;
      height: 20px !important;
    }
    .dropdown-items {
      max-height: 150px !important;
    }
}
</style>
